import { render, staticRenderFns } from "./zhengzhuangtishi.vue?vue&type=template&id=05c07618&"
import script from "./zhengzhuangtishi.vue?vue&type=script&lang=ts&"
export * from "./zhengzhuangtishi.vue?vue&type=script&lang=ts&"
import style0 from "./zhengzhuangtishi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports